import React from "react";

const Card = ({ children, className = "", padding = true, ...props }) => {
  return (
    <div
      className={`
        bg-surface-card rounded-card shadow-elevation-1
        ${padding ? "p-card-p" : ""}
        ${className}
      `.trim()}
      {...props}
    >
      {children}
    </div>
  );
};

const CardHeader = ({ title, subtitle, action, className = "" }) => (
  <div className={`flex items-center justify-between mb-4 ${className}`}>
    <div>
      <h3 className="text-subtitle text-content-primary m-0">{title}</h3>
      {subtitle && (
        <p className="text-caption text-content-secondary m-0 mt-0.5">{subtitle}</p>
      )}
    </div>
    {action && <div>{action}</div>}
  </div>
);

Card.Header = CardHeader;
export default Card;
